import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft } from "lucide-react";

export default function PostDetail() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/posts/${id}`).then(({ data }) => setPost(data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return (
      <div className="container-cuidar py-24 text-center">
        <h1 className="font-heading text-3xl font-black">Postagem não encontrada</h1>
        <Link to="/timeline" className="mt-4 inline-block text-[hsl(var(--primary))] link-underline" data-testid="post-not-found-back">← Voltar para postagens</Link>
      </div>
    );
  }

  if (!post) {
    return <div className="container-cuidar py-24 text-[hsl(var(--muted-foreground))]">Carregando…</div>;
  }

  return (
    <article className="pb-20">
      <div className="container-cuidar pt-10">
        <Link to="/timeline" className="inline-flex items-center gap-1.5 text-sm text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))]" data-testid="post-back-link">
          <ArrowLeft className="h-4 w-4" /> Voltar
        </Link>
      </div>
      <header className="container-cuidar mt-6 max-w-3xl">
        <Badge className="rounded-full bg-[hsl(var(--secondary))]/20 text-[hsl(var(--secondary))] border-transparent">{post.category || "Postagem"}</Badge>
        <h1 className="mt-4 font-heading text-4xl sm:text-5xl font-black leading-[1.05]">{post.title}</h1>
        <div className="mt-4 text-sm text-[hsl(var(--muted-foreground))]">
          por <span className="font-medium">{post.author_name}</span>
          {post.created_at && ` · ${new Date(post.created_at).toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" })}`}
        </div>
      </header>
      {post.cover_image && (
        <div className="container-cuidar mt-8">
          <img src={post.cover_image} alt={post.title} className="w-full h-[300px] sm:h-[420px] object-cover rounded-[2rem]" />
        </div>
      )}
      <div className="container-cuidar mt-10 max-w-3xl">
        <div className="prose-cuidar text-[hsl(var(--foreground))] text-lg leading-relaxed whitespace-pre-wrap">
          {post.content}
        </div>
      </div>
    </article>
  );
}
